module.exports = __webpack_public_path__ + "img/deleteBgImageWhite.a8afe3fa.svg";